import { CloudXIcon, StopCircleIcon } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function ErrorE() {
  return (
    <div
      id="error-page"
      className="grid h-screen w-screen items-center justify-center content-center text-center font-traffic"
    >
      <title>یافت نشد</title>
      <meta name="robots" content="noindex" />

      <CloudXIcon
        weight="bold"
        color="darkRed"
        size={60}
        className="place-self-center"
      />
      <h1>!Oops</h1>
      <p>خطایی رخ داد</p>

      <Link
        to="/"
        title="خانه"
        className="bg-linear-to-l from-green-700 to-green-600 text-green-50 shadow rounded-lg p-1 px-3 text-xl"
      >
        بازگشت به صحفه اصلی
      </Link>
    </div>
  );
}
